import { sendAnalytics } from '@storefront/app/analytics/SimpleTriggerEvent';
import { env } from 'next-runtime-env';
import { uiEvents } from '@storefront/services/DataCollection/simpleUiEvents';
import { TFunction } from 'i18next';

const sendAnalyticsHLC = (
  href: string,
  controlName: string,
  nameSpace?: string
) => {
  const productAnalytics =
    nameSpace === 'instant_ink'
      ? uiEvents.disclaimerGenericIIHLC
      : uiEvents.disclaimerGenericHLCprinter;
  sendAnalytics({
    simpleUiEvent: { ...productAnalytics, controlName, controlDetail: href },
  });
};

export const getTranslatedComponents = (t: TFunction, nameSpace?: string) => ({
  myAccount: {
    href: env('NEXT_PUBLIC_MY_ACCOUNT'),
    id: 'disclaimer-my-account-link',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'MyAccount', nameSpace),
  },
  hpOnePrivacy: {
    href: t('termsOfService.termsOfService'),
    id: 'disclaimer-hp-one-privacy-link',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'TermsOfService', nameSpace),
  },
  proLiveSupport: {
    href: t('termsOfService.proLiveSupport'),
    id: 'disclaimer-pro-live-support',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'ProLiveSupport', nameSpace),
  },
  nextDayReplacement: {
    href: t('termsOfService.nextDayReplacement'),
    id: 'disclaimer-next-day-replacement',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(
        event.currentTarget.href,
        'NextBusinessDayReplacement',
        nameSpace
      ),
  },
  mobilePrinting: {
    href: t('termsOfService.mobilePrinting'),
    id: 'disclaimer-mobile-printing',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'MobilePrinting', nameSpace),
  },
  hpAi: {
    href: t('termsOfService.hpAi'),
    id: 'disclaimer-hp-ai',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'HpAi', nameSpace),
  },
  hpsmart: {
    href: t('termsOfService.hpSmart'),
    id: 'disclaimer-hp-smart',
    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
      sendAnalyticsHLC(event.currentTarget.href, 'HpSmart', nameSpace),
  },
});
